<template>
  <v-sheet>
    <p>A house is a property. Something like a block of flats.</p>
    <p>Each house will belong to a landlord.</p>
    <p>Each house can have one or multiple units.</p>
    <p>If you are generating monthly rent amount manually, you will have an option to select a house and all the units in that house will have the rent generated.</p>
  </v-sheet>
</template>
